import { ClickableAction } from '../Clickable/consts';
import Icon from '../Icon/Icon';
import LinkButton from '../LinkButton/LinkButton';
import TeaserImageCard from '../TeaserImageCard/TeaserImageCard';
import styles from './CourseCategoryTeaser.module.scss';
import type { CourseCategoryTeaserProps } from './types';

const CourseCategoryTeaser = ({
  courseAmount,
  description,
  image,
  path,
  title,
}: CourseCategoryTeaserProps) => {
  const courseLabel = `Kurs${courseAmount === 1 ? '' : 'e'}`;
  const buttonLabel = `${courseLabel} anzeigen`;
  const customDataLayer = {
    customClickText: buttonLabel,
    clickContext: title,
  };

  return (
    <TeaserImageCard
      image={image}
      actionType={ClickableAction.Linkintern}
      linkintern={path}
      imageAspectRatio="2 / 1"
      maxResponsiveSize="l"
      className={styles.base}
      clickContext={title}
      customDataLayer={customDataLayer}
    >
      <TeaserImageCard.Headline>{title}</TeaserImageCard.Headline>
      <TeaserImageCard.Text>{description}</TeaserImageCard.Text>
      <TeaserImageCard.Footer>
        <div className={styles.amountInfo}>
          <Icon variant="user/training" size="iconSize24" />
          <span>
            {courseAmount} {courseLabel}
          </span>
        </div>
        <LinkButton
          align="right"
          as="div"
          className={styles.button}
          disableTransition
          icon="action/arrow-right"
          iconPosition="right"
          size="medium"
          variant="default"
        >
          {buttonLabel}
        </LinkButton>
      </TeaserImageCard.Footer>
    </TeaserImageCard>
  );
};

export default CourseCategoryTeaser;
